<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import Alert from '@components/Alert.svelte';
  import Notification from '@utils/notification';
  import AffiliateUrlAjax from '@ajax/affiliate_url';

  const dispatch = createEventDispatcher();

  export let mobile = false;
  export let msg = 'Would you like to convert existing links on your Benable lists into affiliate links?';
  export let linkRegex = '.*';
  export let successMessage = 'Updating affiliate links (takes up to 10 minutes)';

  let saving = false;

  const convertLinks = async function () {
    saving = true;
    await AffiliateUrlAjax.convertLinksToAffiliate(linkRegex);
    saving = false;

    Notification.send({ text: successMessage });
  };

  const close = function () {
    dispatch('close');
  };
</script>

<style style="text/scss" lang="scss">
  .alert-cancel-btn {
    color: #000;
    font-size: 15px;
    margin-top: 12px;
    font-weight: 500;
    border: none;
    background: transparent;
    display: block;

    &:hover {
      opacity: 0.75;
    }
  }
</style>

<Alert mobile={mobile} question={msg} objectText={null} show={true}>
  <svelte:fragment slot="action">
    <Button
      loading={saving}
      loadingText="Processing"
      text="Yes"
      on:click={async () => {
        await convertLinks();
        close();
      }} />

    <a href="#" on:click|preventDefault|stopPropagation={close} class="alert-cancel-btn {$$props.cancelButtonClass}">
      No
    </a>
  </svelte:fragment>
</Alert>
